// extracted by mini-css-extract-plugin
export default {"input-wrapper":"Input_input-wrapper__WzRqH","MuiTextField-root":"Input_MuiTextField-root__4Sn+k"};